export const RootPath = {
  index: "/equities/desktop",
  trade: "/equities/desktop/trade",
  tradeInstrument,
  orderHistory: "/equities/desktop/orderhistory",
  positions: "/equities/desktop/positions",
}

function tradeInstrument(symbol: string) {
  return `${RootPath.trade}/instrument/${symbol}`
}
tradeInstrument.routePattern = `${RootPath.trade}/instrument/:symbol`
